/// <amd-module name="SuiteCommerce.ShippingBar.Common.Configuration"/>
define("SuiteCommerce.ShippingBar.Common.Configuration", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var environment = null;
    var Configuration = /** @class */ (function () {
        function Configuration() {
        }
        Object.defineProperty(Configuration, "environment", {
            set: function (environmentComponent) {
                environment = environmentComponent;
            },
            enumerable: true,
            configurable: true
        });
        Configuration.get = function (key) {
            if (environment) {
                return environment.getConfig(key);
            }
            console.error('Please set the Environment Component in the Configuration.');
            return null;
        };
        Configuration.getSelectedCurrency = function () {
            if (environment && environment.getSession()) {
                return environment.getSession().currency;
            }
            return null;
        };
        Configuration.shippingGoal = function () {
            return this.get('shippingbar.shippingGoal');
        };
        Configuration.currency = function () {
            return this.get('shippingbar.currency');
        };
        Configuration.getMultiCurrency = function () {
            return this.get('shippingbar.multiCurrency') || [];
        };
        Configuration.showCartBanner = function () {
            return this.get('shippingbar.showCartBanner');
        };
        Configuration.showDetailBanner = function () {
            return this.get('shippingbar.showDetailBanner');
        };
        return Configuration;
    }());
    exports.Configuration = Configuration;
});
